// SSE protocol parser for /api/turn/stream.
//
// Mirrors frontend/app.js exactly — do not redesign the protocol.
// Event types (matching engine.TurnStream*):
//   meta       — {cached, cached_audio_url}
//   narration  — raw text chunk
//   audio      — base64-encoded MP3 chunk
//   done       — {new_turn, location_name, ambient_image_url,
//                 ambient_audio_url, sfx_url, is_investigation}
//   error      — {error, code?}

export interface SseEvent {
  type: string;
  data: string;
}

export function parseSseEvent(raw: string): SseEvent | null {
  let type = "message";
  const dataLines: string[] = [];
  for (const line of raw.split("\n")) {
    if (line.startsWith("event: ")) type = line.slice(7);
    else if (line.startsWith("data: ")) dataLines.push(line.slice(6));
  }
  return { type, data: dataLines.join("\n") };
}

export function b64ToBytes(b64: string): Uint8Array {
  const bin = atob(b64);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}
